import { render, staticRenderFns } from "./PhilLogin.vue?vue&type=template&id=cbf52d02&"
import script from "./PhilLogin.vue?vue&type=script&lang=js&"
export * from "./PhilLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports